import request from '@/utils/request'

const state = {
  revenueTypeList: [],
}

const mutations = {
  SET_REVENUE_TYPE_LIST(state, list) {
    state.revenueTypeList = list
  },
}

const actions = {
  fetchRevenueTypeList({ commit }) {
    return request({
      url: '/api/backend/revenueLog/getRevenueTypeList',
      method: 'get',
    }).then((res) => {
      commit('SET_REVENUE_TYPE_LIST', res.data || [])
      return res.data
    })
  },
}

const getters = {
  revenueTypeList: (state) => state.revenueTypeList,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
